import SubmissionForm from './SubmissionForm';

export default SubmissionForm;
export type { SubmissionFormProps } from './SubmissionForm';
